import Button from 'components/Common/Button'
import { Typography, Box } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import React, { useCallback, useRef } from 'react'
import * as yup from 'yup'

import PhoneField from 'components/Common/PhoneField'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'

const schema = yup.object({
  phone: yup.string().required('Phone number is required'),
})

const sx = {
  textWrapper: {
    marginBottom: theme => theme.spacing(2),
  },
  button: {
    marginTop: theme => theme.spacing(3),
    marginBottom: theme => theme.spacing(2),
  },
  fieldWrapper: {
    minHeight: 85,
    marginBottom: theme => theme.spacing(1),
  },
  title: {
    lineHeight: '39px',
  }
};

const initialValue = {
  phone: '',
}

export const PhoneForm = ({ onNextStep }) => {
  const formik = useRef(null)

  const onFormSubmit = useCallback((values, formikHelpers) => {

    formikHelpers.setSubmitting(true)
  }, [])


  return (
    <>
      <Typography variant="h3" sx={sx.title}>
        Authenticate Your Phone Number
      </Typography>
      <Box sx={sx.textWrapper}>
        <Typography>
          To keep your experience at Markaaz fraud and scam free, please enter your phone number to get an
          authentication code.
        </Typography>
      </Box>
      <Formik
        innerRef={formik}
        validationSchema={schema}
        initialValues={initialValue}
        onSubmit={onFormSubmit}
        validateOnBlur={true}
      >
        {({ isSubmitting, isValid }) => (
          <Form>
            <Box sx={sx.fieldWrapper}>
              <Field name="phone">
                {({ field, meta }) => (
                  <PhoneField
                    {...field}
                    fullWidth
                    placeholder="ex (XXX) XXX-XXXX"
                    label="Phone Number"
                    error={Boolean(meta.touched && meta.error)}
                    helperText={meta.touched && meta.error}
                    disabled={false}
                  ></PhoneField>
                )}
              </Field>
            </Box>

            <Button
              fullWidth
              sx={sx.button}
              disabled={isSubmitting || !isValid}
              type={!isValid ? DISABLED_BUTTON : PRIMARY_BUTTON}
              loading={isSubmitting}
              submit
            >
              Send Code
            </Button>
          </Form>
        )}
      </Formik>
    </>
  )
}
